import React from 'react';
import PropTypes from 'prop-types';

import SelectUser from "core/gd-ui/select-user/select-user";

export default class UserComponentProto extends React.Component {

    static propTypes = {
        renderMode: PropTypes.oneOf(['list','view','edit','form-new']).isRequired,
        renderValue: PropTypes.oneOf(['name','icon-name']),

        value: PropTypes.any,
        options: PropTypes.array,
        placeholder: PropTypes.string,
        canEdit: PropTypes.bool,
        canHaveNoValue: PropTypes.bool,

        underlined: PropTypes.string,

        onUserSelect: PropTypes.func,
        addUserCallback: PropTypes.func,
        onTogglePopover: PropTypes.func,
    };

    constructor(props) {
        super(props);

        this.state = {
            value: props.value,
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.value !== this.props.value) {
            this.setState({
                value: this.props.value
            });
        }
    }

    render() {
        return (
            <SelectUser className={this.props.className}
                        value={this.state.value}
                        options={this.props.options}
                        renderValue={this.props.renderValue}
                        onUserSelect={this.props.onUserSelect}
                        underlined={!_.isNil(this.props.underlined) ? this.props.underlined : 'on-hover'}
                        disabled={!_.isNil(this.props.canEdit) ? !this.props.canEdit : false}
                        addUserLabel="Add user"
                        addUserCallback={this.props.addUserCallback}
                        placeholder={this.props.placeholder}
                        canHaveNoValue={!_.isNil(this.props.canHaveNoValue) ? this.props.canHaveNoValue : true}
                        noValueValue={null}
                        avatarSize={'22'}
                        noValueLabel={this.props.placeholder}
                        onTogglePopover={this.props.onTogglePopover}/>
        );
    }
}